import { QueuePlayNext } from '@mui/icons-material';
import { Box, Typography, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ButtonLink } from '~/components/link';
import { useLink } from '~/hooks/link';

export const StatusToggleContainer = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.field,
  padding: theme.spacing(0, 1),
  borderRadius: theme.spacing(0.5),
  display: 'flex',
  alignItems: 'center',
  height: '40px',
  gap: theme.spacing(1),
  [theme.breakpoints.down('sm')]: {
    display: 'none',
  },
  '& .MuiButton-root': {
    fontWeight: 500,
    fontSize: '16px',
    textTransform: 'none',
    minHeight: 0,
    padding: theme.spacing(0, 2),
  },
}));

export const ActivateButton = () => {
  const { t } = useTranslation();
  const link = useLink();
  return (
    <ButtonLink
      variant="contained"
      color="primary"
      size="medium"
      startIcon={<QueuePlayNext />}
      to={link('/devices/activate')}
    >
      {t('pages.devices.activate_button')}
    </ButtonLink>
  );
};

export const DeviceInfo = styled('div')({
  textAlign: 'right',
});

export const DeviceTitle = styled(Typography)({
  marginLeft: '5px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  fontSize: '16px',
});

export const OverlayContainer = styled('div')(({ theme }) => ({
  opacity: 0,
  display: 'flex',
  position: 'absolute',
  top: 0,
  left: 0,
  padding: theme.spacing(0, 1, 0.5),
  color: theme.palette.common.white,
  fontSize: 14,
  fontWeight: 600,
  width: '100%',
  height: '100%',
  alignItems: 'flex-end',
  backgroundColor: 'rgba(0, 0, 0, .3) !important',
}));

export const ThumbnailContainer = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  position: 'relative',
  '&::before': {
    content: '""',
    display: 'block',
    paddingBottom: 'calc(100% / 16 * 9)',
  },
  '& > :first-of-type': {
    backgroundColor: theme.palette.common.white,
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100%',
    width: '100%',
    overflow: 'hidden',
  },
}));
